import { Component, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-authentication-layout', 
  standalone:false,
  templateUrl: './authentication-layout.component.html',
  styleUrl: './authentication-layout.component.scss'
})
export class AuthenticationLayoutComponent {

}
